import { Component, Input, OnInit, OnDestroy } from "@angular/core";

import { config as CONFIG } from "app/app.config";
import { DetalleContratistaComponent } from "app/main/apps/mantenedores/contratista/detalle-contratista/detalle-contratista.component";
import { InvitacionesDTO } from "app/main/apps/shared/interfaces/invitacion-trabajo.interface";

import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";

import { finalize } from "rxjs/operators";
import { Subscription } from "rxjs";
import { TooltipPosition } from "@angular/material/tooltip";

import { VisitaService } from "app/main/apps/shared/services/rest/visita.service";
import { InvitacionCotizarDTO } from "app/main/apps/shared/interfaces/invitacion.interface";

@Component({
    selector: "app-listado-invitaciones-contratistas",
    templateUrl: "./listado-invitaciones-contratistas.component.html",
    styleUrls: ["./listado-invitaciones-contratistas.component.scss"],
})
export class ListadoInvitacionesContratistasComponent
    implements OnInit, OnDestroy {
    @Input() idServicioSolicitudCotizacion: number;

    config;
    invitaciones: InvitacionCotizarDTO[] = [];
    cargandoInvitaciones: boolean;
    subscripciones: Subscription;
    tooltipPosition: TooltipPosition;
    constructor(
        private _visitaSrvc: VisitaService,
        private _dialogSrvc: DialogService
    ) {
        this.tooltipPosition = "above";
        this.config = CONFIG;
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this._visitaSrvc.invitacionesRefresh$.subscribe((resp) => {
            this.getInvitaciones();
        });
    }

    getInvitaciones() {
        this.cargandoInvitaciones = true;

        this._visitaSrvc
            .fetchInvitaciones(this.idServicioSolicitudCotizacion)
            .pipe(finalize(() => (this.cargandoInvitaciones = false)))
            .subscribe((resp) => (this.invitaciones = resp));
    }

    verFichaContratista(rutContratista: number) {
        this._dialogSrvc.abrirDialog(
            DetalleContratistaComponent,
            "clase-dialog",
            "800px",
            rutContratista
        );
    }

    ngOnDestroy() {}
}
